// created this file to address the fact that we need to tell moment
// what locale to use
// the prime place for this imo was the i18n initialization BUT moment
// is not needed for logging in (atm) and it increases our pre-logged in bundle
// enough
// this file ensures that no matter when moment is called on that we have
// set the locale

import {i18n, i18nInitialized} from '@netx/core-locales/i18n-instance';
import moment from 'moment';

i18nInitialized.then(() => {
	// We have to set this manually
	// https://momentjs.com/docs/#/i18n/changing-locale/
	moment.locale(i18n.language);
});

// eslint-disable-next-line import/named
export {type Moment, utc} from 'moment';
export {default} from 'moment';
